// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".accordion-button[data-v-2e7ea8c6]{background-color:#373f50;color:#e7e8ea}", ""]);
// Exports
module.exports = exports;
